import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/w/$slug/settings/boards/$boardId/lists",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/_app/w/$slug/settings/boards/$boardKey/"!</div>;
}
